import { Post } from '@tribeplatform/gql-client/types'
import { dayjs } from '@tribeplatform/react-components/common/lib'
import { PostMemberBar } from '@tribeplatform/react-components/Post'

export const MemberPostsPlaceholder = ({ member, count = 5 }) => {
  return (
    <>
      {[...Array(count)].map((_e, i) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          className="bg-surface px-4 py-6 shadow sm:p-6 sm:rounded-lg flex flex-col space-y-5"
        >
          <PostMemberBar
            showSpace={false}
            post={
              {
                owner: {
                  member,
                },
                createdAt: dayjs().add(-1, 'day').toISOString(),
              } as Post
            }
          />
          <div className="flex-1 space-y-4 py-1">
            <div className="h-4 bg-skeleton rounded-full w-3/4" />
            <div className="space-y-2">
              <div className="h-4 bg-skeleton rounded-full" />
              <div className="h-4 bg-skeleton rounded-full w-5/6" />
              <div className="h-4 bg-skeleton rounded-full" />
            </div>
          </div>
        </div>
      ))}
    </>
  )
}
